import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
export var Prevent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Prevent, _React$Component);

  function Prevent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this._prevent = function (event) {
      event.stopPropagation();
      event.preventDefault();
    };

    return _this;
  }

  var _proto = Prevent.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("span", {
      onClick: this._prevent
    }, this.props.children);
  };

  return Prevent;
}(React.Component);